import { useState, useEffect, useCallback } from 'react';
import { getProfessionalByUid, getProfessionalStudies } from '../services/professionalService';
import { 
  ProfileData, 
  profesionStudies,
  UseProfessionalDetailResult 
} from '../types/Profesionals/professional';

export function useProfessionalDetail(
  professionalUid: string | undefined
): UseProfessionalDetailResult {
  const [professional, setProfessional] = useState<ProfileData | null>(null);
  const [studies, setStudies] = useState<profesionStudies[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | [] | null>(null);

  const fetchProfessional = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      if (professionalUid){
        const data = await getProfessionalByUid(professionalUid);
        if (data && data.profile && data.profile.uid) {
          const studiesData = await getProfessionalStudies(data.profile.uid);
          setStudies(studiesData);
        }
        setProfessional(data);
      }
    } catch (err: any) {
      setError(err?.message || 'Error al cargar profesional');
    } finally {
      setLoading(false);
    }
  }, [professionalUid]);

  useEffect(() => {
    if (professionalUid) {
      fetchProfessional();
    }
  }, [professionalUid, fetchProfessional]);

  return { professional, studies, loading, error, refetch: fetchProfessional };
}